import React from "react";

// import styles from "./styles/Details.module.scss"
import { ROUTES } from "./contants";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";
import TermsAndConditions from "./TermsAndConditions";
import PrivacyPolicy from "./PrivacyPolicy";
import { IoIosArrowBack } from "react-icons/io";
import ContactUs from "./ContactUs";
import BacratRules from "./BacratRules";
import BlackJackRules from "./BlackJackRules";
import SlotMachineRules from "./SlotMachineRules";
import PrizePoolRules from "./PrizePoolRules";
import DigitDreamRules from "./DigitDreamRules";
import CoinConversion from "./CoinConversion";

export default function Details({ isMobile = false, route = "", setRoute }) {
  const handleBackButtonClck = () => {
    setRoute("");
  };

  return (
    <div className={"Details"}>
      {!isMobile ? (
        ""
      ) : (
        <span className={"backButton"} onClick={handleBackButtonClck}>
          <IoIosArrowBack />
        </span>
      )}
      {route === ROUTES.EDIT_PROFILE ? (
        <EditProfile />
      ) : route === ROUTES.CHANGE_PASSWORD ? (
        <ChangePassword />
      ) : route === ROUTES.TERMS_CONDITIONS ? (
        <TermsAndConditions />
      ) : route === ROUTES.PRIVACY_POLICY ? (
        <PrivacyPolicy />
      ) : route === ROUTES.BACCARAT_RULES ? (
        <BacratRules />
      ) : route === ROUTES.BLACK_JACK_RULES ? (
        <BlackJackRules />
      ) : route === ROUTES.SLOT_MACHINE_RULES ? (
        <SlotMachineRules />
      ) : route === ROUTES.PRIZE_POOL_RULES ? (
        <PrizePoolRules />
      ) : route === ROUTES.DIGIT_DREAM_RULES ? (
        <DigitDreamRules />
      ) : route === ROUTES.CONTACT_US ? (
        <ContactUs />
      ) : route === ROUTES.COIN_CONVERSION ? (
        <CoinConversion />
      ) : (
        ""
      )}
    </div>
  );
}
